import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Form, Input, Button, Col, Row, Card, Spin, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Formik } from "formik";
import * as yup from "yup";
import { checkLogin } from "../actions";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 24 },
};

class Login extends PureComponent {
  state = {
    username: "",
    password: "",
  };

  render() {
    let alert =
      this.props.auth.status === "error"
        ? message.error(this.props.auth.msg)
        : null;

    return (
      <Spin spinning={this.props.auth.loading}>
        {alert}
        <Row justify="center" align="middle" style={{ height: "100vh" }}>
          <Col
            lg={8} xs={24}
            style={{
              justifyContent: "center",
              alignItems: "center",
              background: "#ffffff",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: 'center',
              }}
            >
              <img
                src="/logo_small.jpg"
                alt="Company Logo"
                style={{
                  width: "250px",
                }}
              />
            </div>
            <div style={{ width: "100%" }}>
              <Card
                id="title-account-login"
                title="Account Login"
                style={{ width: "100%" }}
                headStyle={{
                  color: "#FF0000",
                  borderBottom: "none",
                  textAlign: "center",
                  fontSize: "36px",
                }}
                bordered={false}
              >
                <Formik
                  enableReinitialize={true}
                  initialValues={this.state}
                  validationSchema={yup.object().shape({
                    username: yup.string().required("Username is required"),
                    password: yup.string().required("Password is required"),
                  })}
                  onSubmit={(values) => {
                    this.props.checkLogin(values);
                  }}
                  render={({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Form
                      {...layout}
                      layout="vertical"
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={handleSubmit}
                    >
                      <Form.Item
                        name="username"
                        required={true}
                        validateStatus={
                          touched.username && errors.username
                            ? "error"
                            : undefined
                        }
                        help={
                          touched.username && errors.username
                            ? errors.username
                            : undefined
                        }
                      >
                        <Input
                          prefix={<UserOutlined />}
                          placeholder="Username"
                          name="username"
                          values={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          size="large"
                        />
                      </Form.Item>

                      <Form.Item
                        name="password"
                        required={true}
                        validateStatus={
                          touched.password && errors.password
                            ? "error"
                            : undefined
                        }
                        help={
                          touched.password && errors.password
                            ? errors.password
                            : undefined
                        }
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          placeholder="Password"
                          type="password"
                          name="password"
                          values={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          size="large"
                        />
                      </Form.Item>

                      <Form.Item>
                        <Button
                          size="large"
                          style={{
                            borderRadius: "21px",
                            color: "#ffffff",
                            background: "#FF0000",
                          }}
                          htmlType="submit"
                          block
                        >
                          LOGIN
                        </Button>
                      </Form.Item>
                    </Form>
                  )}
                />
              </Card>
            </div>
          </Col>
        </Row>
      </Spin>
    );
  }
}

export default connect(({ profile, auth }) => ({ profile, auth }), {
  checkLogin: checkLogin.request,
})(Login);
